import { useState } from "react";
// import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { getLocale } from "react-i18nify";
import font from "src/styles/font";

import { updateStatusQuotationDraft, approveQuotationDraft } from "src/api/quotationDraft";

import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MuiSkeleton from '@mui/material/Skeleton';

import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';

import Button from "src/components/core/Button";

const Skeleton = muiStyled(MuiSkeleton)(({ theme }) => ({
  "&.MuiSkeleton-root": {
    borderRadius: 32,
  },
  "&.MuiSkeleton-text ": {
    transform: "scale(1, 0.70)",
    borderRadius: 8,
  },
}));

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    paddingBottom: 0,
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
}));

const ModalRequest = ({
  quotationId,
  isOpen = false,
  onClose,
  onDismiss,
  requirePdf,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const requestQuotation = async () => {
    setIsLoading(true);

    if (requirePdf) {
      await updateStatusQuotationDraft(quotationId)
        .then((res) => {
          setIsLoading(false);
          setIsSuccess(true);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("error: ", err.response);
        });
    } else {
      await approveQuotationDraft(quotationId)
        .then((res) => {
          setIsLoading(false);
            setIsSuccess(true);
        })
        .catch((err) => {
          setIsLoading(false);
            console.log("error: ", err.response);
        });
    }

    
  };

  const handleClose = () => {
    onClose();
    onDismiss();
    setIsSuccess(false);
  }

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 345,
            minHeight: 325,
          },
        },
      }}
    >
      {isLoading ? (
        <>
          <DialogTitle
            sx={{
              p: 3,
              pb: 2,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Skeleton variant="circular" animation="wave" width={44} height={44} sx={{ mb: 1.2 }} />
            <Skeleton variant="rounded" animation="wave" width={190} height={26} />
          </DialogTitle>

          <DialogContent
            sx={{
              px: 3,
              width: "100%",
              textAlign: "center",
              color: "var(--darkgrey-color)",
              fontSize: font.size.sm,
              whiteSpace: "pre-line",
              wordBreak: "break-word"
            }}
          >
            <Skeleton variant="text" animation="wave" width={260} sx={{ fontSize: font.size.md, mx: "auto" }} />
            <Skeleton variant="text" animation="wave" width={220} sx={{ fontSize: font.size.md, mx: "auto" }} />
          </DialogContent>

          <DialogActions sx={{ p: 3 }}>
            <Skeleton variant="rounded" animation="wave" width={140} height={55} />
            <Skeleton variant="rounded" animation="wave" width={140} height={55} sx={{ ml: 1 }} />
          </DialogActions>
        </>
      ) : isSuccess ? (
        <>
          <DialogTitle
            sx={{
              p: 3,
              pb: 2,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ".span-title": {
                mt: 0.5,
                fontSize: font.size.md,
                fontWeight: 600,
                color: "var(--secondary-color)",
              }
            }}
          >
            <CheckCircleSharpIcon sx={{ width: "44px", height: "44px", color: "var(--darkgreen-color)" }} />
            <span className="span-title">สำเร็จ</span>
          </DialogTitle>

          <DialogContent
            sx={{
              px: 3,
              width: "100%",
              textAlign: "center",
              color: "var(--darkgrey-color)",
              fontSize: font.size.sm,
              whiteSpace: "pre-line",
              wordBreak: "break-word"
            }}
          >
            {requirePdf
              ? `เราได้รับคำขอของคุณเรียบร้อยแล้ว\nเราจะส่งใบเสนอราคาไปที่\n“ประวัติการขอใบเสนอราคา” ในโปรไฟล์ของคุณ`
              : `เราได้รับใบเสนอราคาของคุณเรียบร้อยแล้ว\nคุณสามารถเช็คประวัติการขอใบเสนอราคาได้\nใน “Quotation Sale” ของคุณ`
            }
          </DialogContent>

          <DialogActions sx={{ p: 3 }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleClose}
              sx={{
                width: "100%",
                maxWidth: 140,
                borderRadius: 6,
                px: {
                  xs: 2,
                  sm: 3,
                },
                py: 2,
                fontSize: font.size.sm,
              }}
            >
              Dismiss
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogTitle
            sx={{
              p: 3,
              pb: 2,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ".span-title": {
                mt: 0.5,
                fontSize: font.size.md,
                fontWeight: 600,
                color: "var(--secondary-color)",
              }
            }}
          >
            <ErrorSharpIcon sx={{ width: "44px", height: "44px", color: "var(--gold-color)" }} />
            <span className="span-title">
              {requirePdf ? `ส่งคำขอใบเสนอราคาชั่วคราว` : `ยืนยันการส่งใบเสนอราคา`}
            </span>
          </DialogTitle>

          <DialogContent
            sx={{
              px: 3,
              width: "100%",
              textAlign: "center",
              color: "var(--darkgrey-color)",
              fontSize: font.size.sm,
              whiteSpace: "pre-line",
              wordBreak: "break-word"
            }}
          >
            {requirePdf
              ? `หากคุณส่งคำร้องขอใบเสนอราคาชั่วคราวแล้ว\nจะไม่สามารถกลับมาแก้ไขแบบร่างได้อีก`
              : `ส่งไปเสนอราคาโดยไม่ร้องขอให้แอดมิน\nแนบ PDF จาก My Account หากกดยืนยันแล้ว\nจะไม่สามารถกลับมาแก้ไขหรือเปลี่ยนแปลง\nการร้องขอใดๆได้อีก`
            }
          </DialogContent>

          <DialogActions sx={{ p: 3 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={onClose}
              sx={{
                width: "100%",
                maxWidth: 140,
                borderRadius: 6,
                px: {
                  xs: 2,
                  sm: 3,
                },
                py: 2,
                fontSize: font.size.sm,
              }}
            >
              {getLocale() === "th" ? "ยกเลิก" : "Cancel"}
            </Button>

            <Button
              variant="contained"
              size="large"
              onClick={() => requestQuotation()}
              sx={{
                width: "100%",
                maxWidth: 140,
                borderRadius: 6,
                px: {
                  xs: 2,
                  sm: 3,
                },
                py: 2,
                fontSize: font.size.sm,
              }}
            >
              {requirePdf
                ? getLocale() === "th" ? "ขอใบเสนอราคา" : "Request"
                : getLocale() === "th" ? "ยืนยัน" : "Confirm"
              }
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalRequest;
